import React from 'react'
import { components } from 'react-select'

import { ReactComponent as CrossMultiElement } from '../assets/select_multielement_cross.svg'
import * as S from '../styles'

export const MultiValueRemove = (props) => (
  <components.MultiValueRemove {...props}>
    <S.MultiValueRemoveContainer>
      <CrossMultiElement />
    </S.MultiValueRemoveContainer>
  </components.MultiValueRemove>
)
